// TODO:
// This is a placeholder function to pipe through all errors
// from client to normalize/sanitize/report async etc.
// For now it simply return back payload wrapped in an object..

// Maybe potentially turn them into Immutable.js Record?


const processError = (payload, opts = {}) => {
  const entry = { payload };

  return entry;
};


export default processError;



// WEBPACK FOOTER //
// ./src/shared/helpers/processError.js